import gql from "graphql-tag";

export const SET_PREFERENCES_MUTATION = gql`
    mutation SetPreferences($input: SetPreferencesInput!) {
        setPreferences(input: $input) {
            success
        }
    }
`;
